import { render, staticRenderFns } from "./EntityCard.vue?vue&type=template&id=46ba481a&scoped=true&"
import script from "./EntityCard.vue?vue&type=script&lang=js&"
export * from "./EntityCard.vue?vue&type=script&lang=js&"
import style0 from "./EntityCard.vue?vue&type=style&index=0&id=46ba481a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba481a",
  null
  
)

export default component.exports